export const approvals = {
  title: "Approvals",
  description: "Replies and actions your automations and assistant want to take. Nothing goes out until you say so.",
  tabs: {
    pending: "Waiting",
    approved: "Approved",
    rejected: "Rejected",
  },
  kinds: {
    reply_public: "Public reply",
    reply_private: "Private reply",
    send_message: "Direct message",
    hide: "Hide comment",
    delete: "Delete comment",
    bulk: "Bulk action",
  },
  proposedBy: {
    rule: "Rule",
    assistant: "Assistant",
    user: "Teammate",
  },
  status: {
    pending: "Waiting",
    approved: "Approved",
    edited: "Approved with edits",
    rejected: "Rejected",
    expired: "Expired",
  },
  // ALP-74: what happened when the approved action ran
  execution: {
    executed: "Executed",
    failed: "Failed",
    reason: "Not sent: {{reason}}",
  },
  card: {
    original: "Original",
    draft: "AI draft",
    draftEdited: "Edited",
    reason: "Why",
    rule: "Rule",
    noDraft: "No message: this action has no text.",
    windowClosed: "Messaging window closed: this will fail.",
    windowClosedHint: "Instagram only allows a reply within 24 hours of the customer's last message. Wait for them to write again, or reject this draft.",
    openTarget: "Open in inbox",
    expiresIn: "Expires in {{time}}",
    expired: "Expired",
    chars_one: "{{count}} / {{max}}",
    chars_other: "{{count}} / {{max}}",
    select: "Select",
    reset: "Restore the AI draft",
    more: "More actions",
    openRule: "Open rule",
    windowClosedAgo: "Instagram closed this conversation {{when}}. Reply when they write again.",
    windowClosedNow: "Instagram closed this conversation. Reply when they write again.",
  },
  actions: {
    approve: "Approve",
    approveEdited: "Approve edit",
    reject: "Reject",
    approveAll_one: "Approve {{count}}",
    approveAll_other: "Approve {{count}}",
    approveSelected: "Approve selected",
    selectAll: "Select all",
    approved: "Approved and sent",
    approvedEdited: "Your edit was approved and sent",
    rejected: "Rejected",
    batchDone_one: "{{count}} approval sent",
    batchDone_other: "{{count}} approvals sent",
    failed: "Couldn't apply the decision",
    undoHint: "Approved items go out right away.",
  },
  empty: {
    title: "All caught up",
    hint: "No replies are waiting for you. Approve-first rules will send new drafts here.",
    other: "Nothing here yet",
    otherHint: "Decided approvals appear in this tab.",
    filteredHint: "Nothing waiting matches these filters.",
    openRules: "Open rules",
  },
  keyboard: "J/K to move · A approve · R reject · E edit",
  count_one: "{{count}} waiting",
  count_other: "{{count}} waiting",
  keyboardHint: "J / K to move · {{mod}}+Enter approve · R reject · E edit",
  loadMore: "Load more",
  filters: {
    remove: "Remove filter: {{name}}",
  },
  bulk: {
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    approve_one: "Approve {{count}}",
    approve_other: "Approve {{count}}",
    reject_one: "Reject {{count}}",
    reject_other: "Reject {{count}}",
    confirmTitle_one: "Approve {{count}} item?",
    confirmTitle_other: "Approve {{count}} items?",
    confirmLead: "These go out on Instagram right away:",
    confirm: "Approve and send",
    skippedClosed_one: "{{count}} message is skipped: Instagram closed that conversation.",
    skippedClosed_other: "{{count}} messages are skipped: Instagram closed those conversations.",
    kind: {
      reply_public_one: "{{count}} public reply will be posted",
      reply_public_other: "{{count}} public replies will be posted",
      reply_private_one: "{{count}} private reply will be sent",
      reply_private_other: "{{count}} private replies will be sent",
      send_message_one: "{{count}} direct message will be sent",
      send_message_other: "{{count}} direct messages will be sent",
      hide_one: "{{count}} comment will be hidden",
      hide_other: "{{count}} comments will be hidden",
      delete_one: "{{count}} comment will be deleted",
      delete_other: "{{count}} comments will be deleted",
      bulk_one: "{{count}} bulk action will run",
      bulk_other: "{{count}} bulk actions will run",
    },
  },
  likelihood: {
    veryLikely: "very likely",
    likely: "likely",
    possibly: "possibly",
  },
  reasons: {
    withLikelihood: "{{reason}}, {{likelihood}}",
    negative: "Negative comment",
    positive: "Positive comment",
    spam: "Spam",
    hate: "Hateful",
    complaint: "Complaint",
    question: "Question",
    price: "Price question",
    agent: "Suggested by the AI agent",
    promotion: "Contains a promotion",
    assistantSpam: "You asked the assistant to clean up spam",
  },
};
